import { formatCompactNumberExact } from '@ipfabric/utils';

const pRegExp = /P$/;
const tRegExp = /T$/;
const gRegExp = /G$/;
const mRegExp = /M$/;
const kRegExp = /k$/;

const measureUnitToNumber = (value: string): number => {
  if (pRegExp.test(value)) {
    return Number(value.replace(pRegExp, '').trim()) * 1000000000000000;
  }
  if (tRegExp.test(value)) {
    return Number(value.replace(tRegExp, '').trim()) * 1000000000000;
  }
  if (gRegExp.test(value)) {
    return Number(value.replace(gRegExp, '').trim()) * 1000000000;
  }
  if (mRegExp.test(value)) {
    return Number(value.replace(mRegExp, '').trim()) * 1000000;
  }
  if (kRegExp.test(value)) {
    return Number(value.replace(kRegExp, '').trim()) * 1000;
  }
  return Number(value.trim());
};

export const measureUnitValueConvertor = {
  toNumber: measureUnitToNumber,
  toMeasureUnit: formatCompactNumberExact,
};
